
export const ACTIONS = {
    FETCH_URLS: 'FETCH_URLS',
    CREATE_URLS: 'CREATE_URLS',
    DELETE_URLS: 'DELETE_URLS',
    UPDATE_URLS: 'UPDATE_URLS',
    CUSTOM_PRIVATE_URL: 'CUSTOM_PRIVATE_URL',
    CHANGE_TAB: 'CHANGE_TAB',
    REGISTER_TAB: 'REGISTER_TAB',
    UPDATE_DATA_URLS: 'UPDATE_DATA_URLS',
    IS_PROTECTED_FILE: 'IS_PROTECTED_FILE',
    PROTECT_FILE: 'PROTECT_FILE',
    IP_BLOCK: 'IP_BLOCK',
    GET_IP_BLOCK: 'GET_IP_BLOCK',
    GET_USER_ROLES_IP_BLOCK: 'GET_USER_ROLES_IP_BLOCK',
    // PROTECT_FILE: 'PROTECT_FILE',
    SET_DEFAULT: 'SET_DEFAULT',
    GET_ALL_USER_ROLES: 'GET_ALL_USER_ROLES',
    ADD_USER_ROLES: 'ADD_USER_ROLES',
    PRIVATE_SUMMARY: 'PRIVATE_SUMMARY',
    SYNC_TO_S3: 'SYNC_TO_S3',
    UN_SYNC_TO_S3: 'UN_SYNC_TO_S3',
    // GET_IP_BLOCK_SETTING: 'GET_IP_BLOCK_SETTING',
    GET_MEMBERS_SELECT: 'GET_MEMBERS_SELECT',
    CREATE_URL_FOR_USER: 'CREATE_URL_FOR_USER',
    GET_URL_FOR_USER: 'GET_URL_FOR_USER',
    CHECK_STATUS_FILE: 'CHECK_STATUS_FILE',
    GET_PLAN: 'GET_PLAN',
    INIT_DATA: 'INIT_DATA',
}
